module.exports = __webpack_public_path__ + "img/Logo_w_transparent.6e9cd0a0.png";